import { render, staticRenderFns } from "./vip_popup.vue?vue&type=template&id=533fa340&scoped=true"
import script from "./vip_popup.vue?vue&type=script&lang=js"
export * from "./vip_popup.vue?vue&type=script&lang=js"
import style0 from "./vip_popup.vue?vue&type=style&index=0&id=533fa340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533fa340",
  null
  
)

export default component.exports